/* import __COLOCATED_TEMPLATE__ from './getting-started.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();